export default __webpack_public_path__ + "static/media/Months_14.315150df.png";